<!-- <div [style.margin-left.px]="isPremium() ? 350 : 0"> -->
  <div class="container">
    <div class="wrap-content d-flex">
      <figure class="imgwrap">
        <svg
          width="386"
          height="387"
          viewBox="0 0 386 387"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M116.443 75.2784C136.23 55.2797 154.312 24.7205 182.45 25.4696C211.74 26.2493 226.559 61.3598 250.093 78.8363C265.833 90.5254 283.533 97.7053 297.814 111.139C314.682 127.007 333.355 142.06 340.658 164.032C348.986 189.087 356.791 220.344 341.18 241.612C325.309 263.232 292.795 263.132 266.081 265.63C246.619 267.449 228.748 249.016 209.823 253.893C175.544 262.726 152.036 314.99 118.477 303.665C89.8454 294.004 109.022 245.633 99.94 216.813C91.5724 190.261 64.2163 169.352 67.4392 141.711C70.693 113.804 96.6893 95.2429 116.443 75.2784Z"
            fill="white"
          />
          <path
            d="M158.877 132.163H259.418C261.455 132.163 263.47 132.59 265.332 133.416C267.194 134.243 268.862 135.45 270.229 136.96C271.596 138.471 272.632 140.251 273.268 142.186C273.905 144.121 274.13 146.168 273.927 148.196L269.552 191.941C269.193 195.539 267.509 198.875 264.828 201.301C262.147 203.728 258.66 205.072 255.044 205.072H185.416C182.044 205.073 178.775 203.906 176.167 201.768C173.559 199.63 171.772 196.655 171.111 193.348L158.877 132.163Z"
            fill="#D6E6FF"
            stroke="#D6E6FF"
            stroke-width="12"
            stroke-linejoin="round"
          />
          <circle cx="217.5" cy="154.5" r="3.5" fill="black" />
          <circle cx="255.5" cy="150.5" r="3.5" fill="black" />
          <path
            d="M234 186.5C236.667 180 245.2 168.5 258 174.5"
            stroke="black"
            stroke-width="4"
            stroke-linecap="round"
          />
          <path
            d="M158.873 132.163L152.967 108.519C152.572 106.943 151.662 105.543 150.38 104.543C149.099 103.543 147.52 103 145.895 103H137"
            stroke="#D6E6FF"
            stroke-width="12"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M180.74 234.236H195.322"
            stroke="#D6E6FF"
            stroke-width="12"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M239.076 234.236H253.658"
            stroke="#D6E6FF"
            stroke-width="12"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <figcaption class="caption">Your cart is empty</figcaption>
      </figure>
      <!-- <app-purchase-subscription-suggestion-layout></app-purchase-subscription-suggestion-layout> -->
    </div>
  </div>
<!-- </div> -->
